.mu-loading-host { position: relative; min-width: 0; }
.mu-loading-host[data-empty="true"] { min-height: 120px; }
.mu-loading-dim { opacity: 1; transition: opacity 160ms ease 0ms; }
.mu-loading-dim[data-busy="true"] { opacity: 0.55; pointer-events: none; }
.mu-loading-indicator { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; pointer-events: none; opacity: 0; transition: opacity 160ms ease 0ms; }
.mu-loading-indicator[data-busy="true"] { opacity: 1; transition: none; }
.mu-loading-screen { position: fixed; display: flex; align-items: center; justify-content: center; backdrop-filter: blur(2px); }
.mu-loading-placeholder { display: grid; place-items: center; min-height: 180px; }
@media (prefers-reduced-motion: reduce) { .mu-loading-dim, .mu-loading-indicator { transition-duration: 0ms; } }
